import { createSelector } from 'reselect';

const releaseNotesSelector = state => state.releaseNotes;

export default createSelector(releaseNotesSelector, releaseNotes => ({releaseNotes}) );


// WEBPACK FOOTER //
// ./src/selectors/releaseNotesSelector.js